import { Component, Label, Toggle, _decorator } from 'cc';
import Roadmap from '../GameObject/Roadmap/Roadmap';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import Dialog from '../../../../common/scripts/Toolkit/Components/Dialog/Dialog';
import NumberFormatter from '../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import MultiThemeColor from '../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeColor';
import BasicRoadmapLayoutStrategy from '../../Data/Strategy/RoadmapLayout/BasicRoadmapLayoutStrategy';
import { RoadmapItemType } from '../../Data/Strategy/RoadmapLayout/BaseRoadmapLayoutStrategy';
import Lobby from '../../../System/Lobby';
import LobbyMultiplePlayGamePreviewData from '../../Data/DataObject/PreviewData/LobbyMultiplePlayGamePreviewData';
import LobbyRoundPlayGamePreviewData from '../../Data/DataObject/PreviewData/LobbyRoundPlayGamePreviewData';
import HallModel from '../../../../tableEngine/Script/Game/Data/Model/HallModel';

const { ccclass, property, requireComponent } = _decorator;

type DialogDisplayedGameData = LobbyMultiplePlayGamePreviewData | LobbyRoundPlayGamePreviewData;

@ccclass('EnterMachineDialog')
@requireComponent([Dialog])
export default class EnterMachineDialog extends Component {
    @property(Label)
    private readonly machineInfoLabel: Label = null;

    @property(NumberFormatter)
    private readonly liveRTPNumber: NumberFormatter = null;

    @property(NumberFormatter)
    private readonly gameRTPNumber: NumberFormatter = null;

    @property(NumberFormatter)
    private readonly nonFGSpinTimesNumber: NumberFormatter = null;

    @property(NumberFormatter)
    private readonly averageToFGSpinTimesNumber: NumberFormatter = null;

    // @property(NumberFormatter)
    // private readonly minBet: NumberFormatter = null;

    // @property(NumberFormatter)
    // private readonly maxBet: NumberFormatter = null;

    @property(Roadmap)
    private readonly roadmap: Roadmap = null;

    @property
    private readonly spinCountPerItem: number = 10;

    @property(Toggle)
    private readonly favoriteToggle: Toggle = null;

    private _dialog: Dialog = null;
    private _page: Page = null;

    private _displayedGameData: DialogDisplayedGameData = null;
    private _roadmapLauoutStrategy: BasicRoadmapLayoutStrategy = null;

    private get dialog() {
        if (!this._dialog) {
            this._dialog = this.getComponent(Dialog);
        }
        return this._dialog;
    }

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    public onLoad() {
        this._roadmapLauoutStrategy = new BasicRoadmapLayoutStrategy(this.roadmap.size, this.roadmap.size.x, this.spinCountPerItem, [
            RoadmapItemType.BIG_WIN,
            RoadmapItemType.JACKPOT,
            RoadmapItemType.FEATURE_GAME,
        ]);
        this.favoriteToggle.on(Toggle.EventType.TOGGLE, this._onFavoriteToggleChanged, this);
    }

    public async enterMachine(gameData: DialogDisplayedGameData): Promise<boolean> {
        this._displayedGameData = gameData;
        this.favoriteToggle.isChecked = gameData.IsFavorite;

        // setup listeners
        Lobby.hall.on(HallModel.EVENT_TYPE.STATS_DATA_RECEIVED, this._updateMachineStats, this);
        // table.on(LobbyTableModel.EVENT_TYPE.LIVE_RTP_CHANGED, this._updateMachineStats, this);
        // table.on(LobbyTableModel.EVENT_TYPE.NON_FG_SPIN_TIMES_CHANGED, this._updateMachineStats, this);
        // table.on(LobbyTableModel.EVENT_TYPE.AVERAGE_TO_FG_SPIN_TIMES_CHANGED, this._updateMachineStats, this);
        // table.on(LobbyTableModel.EVENT_TYPE.HISTORY_UPDATED, this._updateRoadmap, this);

        // init display
        this.page.open();
        this.machineInfoLabel.string = gameData.Name;
        this._updateMachineStats();
        this._updateRoadmap();
        this._updateMachineInfo();
        // table.requestStatisticData();

        const action = await this.dialog.waitForNextAction();

        // remove listeners
        // table.off(LobbyTableModel.EVENT_TYPE.LIVE_RTP_CHANGED, this._updateMachineStats, this);
        // table.off(LobbyTableModel.EVENT_TYPE.NON_FG_SPIN_TIMES_CHANGED, this._updateMachineStats, this);
        // table.off(LobbyTableModel.EVENT_TYPE.AVERAGE_TO_FG_SPIN_TIMES_CHANGED, this._updateMachineStats, this);
        // table.off(LobbyTableModel.EVENT_TYPE.HISTORY_UPDATED, this._updateRoadmap, this);

        return action === Dialog.EVENT_TYPE.CONFIRM;
    }

    private _updateMachineStats() {
        const { RTP } = this._displayedGameData;
        this.liveRTPNumber.value = RTP * 100;
        this.liveRTPNumber.getComponent(MultiThemeColor).theme = RTP > 1 ? 1 : 0;
        this.gameRTPNumber.value = RTP * 100;
        // this.nonFGSpinTimesNumber.value = nonFGSpinTimes;
        // this.averageToFGSpinTimesNumber.value = averageToFGSpinTimes;
    }

    private _updateRoadmap() {
        // const derivedData = this._roadmapLauoutStrategy.derive(this._displayedGameData.history);
        // this.roadmap.display(derivedData);
    }

    private _updateMachineInfo(): void {
        // const { minBet, maxBet } = this._displayedTable;
        // this.minBet.value = minBet;
        // this.maxBet.value = maxBet;
    }

    private async _onFavoriteToggleChanged(toggle: Toggle) {
        await Lobby.user.updateFavorite(this._displayedGameData.GameID, this._displayedGameData.GameType, toggle.isChecked);
        this._displayedGameData.IsFavorite = toggle.isChecked;
    }
}
